import { eventConstants } from "./constants/eventConstants";

const createEventRequest = (eventData: any) => ({
  type: eventConstants.createEventRequest,
  payload: eventData,
});

const listEventsRequest = (params: any) => ({
  type: eventConstants.listEventsRequest,
  payload: params,
});

const clearCreateEventState = () => ({
  type: eventConstants.clearCreateEventState,
});

const viewEventsRequest = (params:any)=>({
  type: eventConstants.viewEventsRequest,
  payload: params,
})

const updateEventsRequest = (params:any)=>({
  type: eventConstants.updateEventsRequest,
  payload: params,
  
})

const assignMemberToEventsRequest = (data:any)=>({
  type:eventConstants.assignMemberToEventsRequest,
  payload:data
})

const closeEventRequest = (params: any) => ({
  type: eventConstants.closeEventRequest,
  payload: params,
});

const clearCloseEventState = () => ({
  type: eventConstants.clearCloseEventState,
});

const getEventsWithEnquiries = (id: string) => ({
  type: eventConstants.getEventsWithEnquiriesRequest,
  payload: id,
});

const clearUpdateEventState = () => ({
  type: eventConstants.clearUpdateEventState,
});

const clearUpdateEventConfirmation = () => ({
  type: eventConstants.clearUpdateEventConfirmation,
});

const setCurrentEventId = (eventId: string) => ({
  type: "SET_CURRENT_EVENT_ID",
  payload: eventId,
});

const clearCurrentEventId = () => ({
  type: "CLEAR_CURRENT_EVENT_ID",
});

const setEventData = (eventId: string, data: any) => ({
  type: "SET_EVENT_DATA",
  payload: { eventId, data },
});

const updateEventData = (eventId: string, updates: any) => ({
  type: "UPDATE_EVENT_DATA",
  payload: { eventId, updates },
});

const setWorkflow = (eventId: string, workflow: {
  step?: number;
  mode?: "view" | "edit";
  permissions?: any;
}) => ({
  type: "SET_WORKFLOW",
  payload: { eventId, workflow },
});

const updateWorkflowStep = (eventId: string | undefined | null, step: number) => ({
  type: "UPDATE_WORKFLOW_STEP",
  payload: { eventId, step },
});

const updateWorkflowPermissions = (eventId: string | undefined | null, permissions: any) => ({
  type: "UPDATE_WORKFLOW_PERMISSIONS",
  payload: { eventId, permissions },
});

const setLoadedFlag = (
  eventId: string,
  flagName: "event" | "assignment" | "attendance" | "media" | "finance" | "expenses" | "financial",
  value: boolean
) => ({
  type: "SET_LOADED_FLAG",
  payload: { eventId, flagName, value },
});

const setMultipleLoadedFlags = (
  eventId: string,
  flags: {
    event?: boolean;
    assignment?: boolean;
    attendance?: boolean;
    media?: boolean;
    finance?: boolean;
    expenses?: boolean;
    financial?: boolean;
  }
) => ({
  type: "SET_MULTIPLE_LOADED_FLAGS",
  payload: { eventId, flags },
});

const setLoadingFlag = (
  eventId: string,
  flagName: "event" | "assignment" | "attendance" | "media" | "finance" | "expenses" | "financial",
  value: boolean
) => ({
  type: "SET_LOADING_FLAG",
  payload: { eventId, flagName, value },
});

const setMultipleLoadingFlags = (
  eventId: string,
  flags: {
    event?: boolean;
    assignment?: boolean;
    attendance?: boolean;
    media?: boolean;
    finance?: boolean;
    expenses?: boolean;
    financial?: boolean;
  }
) => ({
  type: "SET_MULTIPLE_LOADING_FLAGS",
  payload: { eventId, flags },
});

const setEventError = (eventId: string, error: any) => ({
  type: "SET_EVENT_ERROR",
  payload: { eventId, error },
});

const clearEventError = (eventId: string) => ({
  type: "CLEAR_EVENT_ERROR",
  payload: { eventId },
});

const updateAssignmentInStore = (eventId: string, assignment: any) => ({
  type: "UPDATE_ASSIGNMENT_IN_STORE",
  payload: { eventId, assignment },
});

const initializeEventEntity = (eventId: string, initialData?: any) => ({
  type: "INITIALIZE_EVENT_ENTITY",
  payload: { eventId, initialData },
});

const removeEventEntity = (eventId: string) => ({
  type: "REMOVE_EVENT_ENTITY",
  payload: { eventId },
});

const clearAllEventEntities = () => ({
  type: "CLEAR_ALL_EVENT_ENTITIES",
});

const setDeepLinkContext = (eventId: string | undefined | null, context: {
  assignmentId?: string | null ;
  action?: string;
  fromDeepLink?: boolean;
}) => ({
  type: "SET_DEEP_LINK_CONTEXT",
  payload: { eventId, context },
});

const clearDeepLinkContext = (eventId: string) => ({
  type: "CLEAR_DEEP_LINK_CONTEXT",
  payload: { eventId },
});

const setFinanceData = (eventId: string, financeData: any) => ({
  type: "SET_FINANCE_DATA",
  payload: { eventId, financeData },
});

const setExpenseData = (eventId: string, expenseData: any) => ({
  type: "SET_EXPENSE_DATA",
  payload: { eventId, expenseData },
});

const setFinancialData = (eventId: string, financialData: any) => ({
  type: "SET_FINANCIAL_DATA",
  payload: { eventId, financialData },
});

const updateEventStageRequest = (params: { id: string; stage: string }) => ({
  type: eventConstants.updateEventStageRequest,
  payload: params,
});

const clearUpdateEventStageState = () => ({
  type: eventConstants.clearUpdateEventStageState,
});

export const eventActions = {
  createEventRequest,
  listEventsRequest,
  clearCreateEventState,
  viewEventsRequest,
  updateEventsRequest,
  assignMemberToEventsRequest,
  closeEventRequest,
  clearCloseEventState,
  clearUpdateEventState,
  clearUpdateEventConfirmation,
  setCurrentEventId,
  clearCurrentEventId,
  setEventData,
  updateEventData,
  setWorkflow,
  updateWorkflowStep,
  updateWorkflowPermissions,
  setLoadedFlag,
  setMultipleLoadedFlags,
  setLoadingFlag,
  setMultipleLoadingFlags,
  setEventError,
  clearEventError,
  updateAssignmentInStore,
  initializeEventEntity,
  removeEventEntity,
  clearAllEventEntities,
  setDeepLinkContext,
  clearDeepLinkContext,
  setFinanceData,
  setExpenseData,
  setFinancialData,
  getEventsWithEnquiries,
  updateEventStage: updateEventStageRequest,
  clearUpdateEventStage: clearUpdateEventStageState,
};
